<template>
  <div class="pk-flex__1 pk-flex__h-center pk-page-wrapper">
    <div class="pk-page-body" style="padding:50px; width:800px">
      <span style="color:red">[UNDER DEVELOPMENT]</span>
      <div class="pk-page-block pk-flex">
        <div class="pk-label pk-page-line">search in:</div>
        <div class="pk-flex__1 pk-page-block-body pk-flex">

          <div class="pk-flex pk-page-line" style="border:2px solid #bbb; border-radius: 2px; width:200px">
            <div style="height:100%;width:30px" class="pk-flex__vh-center">
              <input type="radio" name="searchin" checked="">
            </div>
            <div style="border-left:1px solid #bbb; height: 100%" class="pk-flex__1 pk-flex__vh-center">
              Archive Editions
            </div>
          </div>
          <div class="pk-flex pk-page-line" style="margin-left:10px; border:2px solid #bbb; border-radius: 2px; width:200px">
            <div style="height:100%;width:30px" class="pk-flex__vh-center">
              <input type="radio" name="searchin">
            </div>
            <div style="border-left:1px solid #bbb; height: 100%" class="pk-flex__1 pk-flex__vh-center">
              Archive Editions
            </div>
          </div>
        </div>
      </div>

      <div class="pk-page-block pk-flex" style="margin-top:20px">
        <div class="pk-label pk-page-line">search for:</div>
        <div class="pk-flex__1 pk-page-block-body pk-flex">
          <div class="pk-flex pk-page-line">
            <div class="input-group">
              <input type="text" class="form-control" ref="search" id="basic-url" aria-describedby="basic-addon3">
              <span class="input-group-addon"><img src="../assets/icons/search.svg"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="pk-page-block pk-flex" style="margin-top:20px">
        <div class="pk-label pk-page-line">result:</div>
        <div class="pk-flex__1 pk-page-block-body pk-flex">
          <div class="pk-flex pk-page-line">

          </div>
        </div>
      </div>
    </div>

  </div>
  <!--<div class="container-fludid">
    <div class="row" style="margin-top:100px">
      <div class="col-lg-6">
        <div class="pk-flex pk-search-wrapper">
          <span class="pk-flex__00auto">Search</span>
          <input type="text" class="pk-flex__1" ref="search" v-model="searchKey" placeholder="">
            <img class="pk-flex__00auto" src="../assets/icons/search.svg" @click="doSearch" >          
        </div>
      </div>
    </div>
    <div class="row pk-search-result" style="margin-top:20px">
      <ul>
        <li v-for="it of searchResult">
          <router-link :to="{path:'/archive'}" @click.native="selectSlideset(it)">{{it.doc._source['54_ssmaintitle']}} {{it._id}}</router-link>
        </li>
      </ul>
    </div>

  </div>-->
</template>

<script>
import Vue from 'vue';
export default Vue.extend({
  data() {
    return {
      searchKey: ''
    };
  },
  mounted() {
    if (this.$matomo) {
      this.$matomo.trackPageView('Search');
    }
    this.$refs.search.focus();
    this.$store.dispatch('fetchSearchResult');
  },
  computed: {
    searchResult() {
      return this.$store.state.searchResult;
    }
  },
  methods: {
    doSearch() {
      // return this.$store.dispatch('search', this.key);
    },
    selectSlideset(item) {
      this.$store.dispatch('archive.select.slideset', item);
      this.$store.dispatch('archive.select.navItem', 'slideset');
    }
  }
});
</script>

<style lang="scss" scoped>
@import '../assets/scss/variable.scss';
@import '../assets/scss/layout.scss';
@import '../assets/scss/color.scss';
@import '../assets/scss/size.scss';

.pk-search-wrapper * {
  height: 100%;
}

.pk-label {
  width: 100px;
  background-color: #ddd;
  margin-bottom: 10px;
  padding-left: 10px;
}

.pk-page-block-body {
  margin-left: 20px;
}

.pk-page-line {
  height: 30px;
  display: flex;
  align-content: center;
  align-items: center;
}
</style>